import * as angular from 'angular';
import {ngStorage} from 'ngstorage';
import {UserDto} from "../model/UserDto";
import {UserFullDto} from "../model/UserFullDto";

export class ConfigService {
    public apiBase: string;
    public loggedIn: boolean = false;
    public loginTimestamp: Date;
    private onLoginCallbacks: { (): void; }[] = [];
    public txnDateFormat = "yyyy-MM-dd";
    public timeStampFormat = "yyyy-MM-dd (EEE) hh:mm:ss a"

    constructor(
        private $http: ng.IHttpService,
        private $location: ng.ILocationService,
        private $q: ng.IQService,
        private $rootScope: ng.IRootScopeService,
        private $window: ng.IWindowService,
        private $localStorage: ngStorage.StorageService) {

        this.apiBase = $window.apiBase;
        console.debug('apiBase', this.apiBase);

        $rootScope.$watch(() => $localStorage.loginTimestamp,
            () => {
                this.loggedIn = $localStorage.loggedIn || false;
                this.loginTimestamp = new Date($localStorage.loginTimestamp);
            });
    }

    // define common API endpoints

    get accountLogin() {
        return this.apiBase + 'account/login';
    }

    get accountUserInfo() {
        return this.apiBase + 'auth/userinfo';
    }

    get accountLogout() {
        return this.apiBase + 'account/logout';
    }

    get production() {
        return this.$window.environment == "production";
    }

    get devMode() {
        return !this.production;
    }


    checklogin = () => {
        var q = this.$q.defer<UserDto>();

        var now = new Date().valueOf();
        var lastTs = new Date(this.$localStorage.loginTimestamp).valueOf();
        var diff = now - lastTs;
        if (diff < 10000 && this.userInfo) {
            q.resolve(this.userInfo);
            return q.promise;
        }


        this.$http.get<UserFullDto>(this.accountUserInfo)
            .then(r => {
                //console.debug('checklogin: logged in', r.data);
                this.userInfo = r.data;
                this.$localStorage.loggedIn = true;
                this.$localStorage.loginTimestamp = new Date();
                this.onLoginInvoke();
                q.resolve(r.data);
            })
            .catch(e => {
                console.error('checkLogin', e);
                if (e.status == 401) {
                    this.userInfo = null;
                    this.$localStorage.loggedIn = false;
                    this.$localStorage.loginTimestamp = new Date();
                }
                q.reject(e.data ? e.data.message : e.xhrStatus);
            });
        return q.promise;
    };

    login = (username: string, password: string) => {
        var q = this.$q.defer<UserDto>();
        this.$http.post(this.accountLogin, {username: username, password: password, rememberMe: false})
            .then(r => {
                console.log('login result', r);
                this.checklogin()
                    .then(q.resolve)
                    .catch(q.reject);
            })
            .catch(e => {
                console.log('login error', e);
                if (e.data && e.data.modelState) {
                    var ms = e.data.modelState;
                    var errorMsg = '';
                    Object.keys(ms)
                        .forEach((key) => {
                            var msgs = ms[key];
                            errorMsg += '\n' + msgs.reduce((l, r) => l + '\n' + r);

                        });
                    q.reject(errorMsg.trim());
                } else {
                    q.reject(e);
                }
            });
        return q.promise;
    };

    logout = () => {
        var q = this.$q.defer();
        this.$http.post(this.accountLogout, null)
            .then(r => {
                console.log('logout complete', r);
                this.$localStorage.loggedIn = false;
                this.$localStorage.loginTimestamp = new Date();
                q.resolve(r);
            })
            .catch(e => {
                console.log('logout error', e);
                q.reject(e);
            });
        return q.promise;
    }

    public onLogin(callback: () => void) {
        this.onLoginCallbacks.push(callback);
    }

    private onLoginInvoke = () => {
        for (var f of this.onLoginCallbacks) {
            try {
                f.apply(this);
            } catch (e) {
                console.error(e);
            }
        }
    }

    get userInfo(): UserFullDto {
        return this.$localStorage.userInfo;
    }

    set userInfo(value: UserFullDto) {
        this.$localStorage.userInfo = value;
    }
}

export default angular.module('services.config', [])
    .service('$config', ConfigService)
    .name;
